export const ShippingMethodTypeEnum = Object.freeze({
  Standard: 0,
  Expedited: 1,
  Pickup: 2
})

export const ShippingMethodIdentifierEnum = Object.freeze({
  Pickup: 1,
  StandardShipping: 2,
  ExpeditedShipping: 3,
  CanadaStandardShipping: 4
})

export const CountryEnum = Object.freeze({
  US: 1,
  Canada: 2
})
